import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './BreadExpandTab.less';

export default function BreadExpandTab({
  type,
  data,
  handleBreadItemClick,
  options,
  index
}) {
  const [INFO_MAP] = useState(options);
  const [expand, setExpand] = useState(false);
  const [infoObj, setInfoObj] = useState({});

  const handleExpand = () => setExpand(!expand);

  useEffect(() => {
    setInfoObj(INFO_MAP[type]);
  }, [INFO_MAP, type]);

  useEffect(() => {
    index === 0 && setExpand(true);
  }, [index]);

  return (
    <div className={css.breadExpandTabWrap}>
      <div
        className={[css.breadExpandTabItem, css.breadExpandTabHeader].join(' ')}
        style={{ background: infoObj.titleColor }}
        onClick={handleExpand}
      >
        {infoObj.title}（{data && data.length}）
        <span
          className={[css.triangle, expand ? `${css.triangleRotate}` : ''].join(
            ' '
          )}
        />
      </div>
      <ul
        className={[
          css.breadExpandTabContent,
          expand ? `${css.max1000}` : `${css.max0}`
        ].join(' ')}
      >
        {data &&
          data.length &&
          data.map((e, key) => (
            <li key={key} onClick={() => handleBreadItemClick(e, key, infoObj)}>
              <span
                style={{ color: infoObj.titleColor }}
                className={css.breadExpandTabContentItem}
              >
                {key + 1}. &nbsp;{e[infoObj.itemKey] || e[infoObj.backupKey]}
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
}

BreadExpandTab.displayName = 'BreadExpandTab';

BreadExpandTab.propTypes = {
  type: PropTypes.string,
  data: PropTypes.array,
  handleBreadItemClick: PropTypes.func
};
